export const ADMIN_REDACTION_GET = 'ADMIN_REDACTION_GET';
export const ADMIN_REDACTION_GET_SUCCESS = 'ADMIN_REDACTION_GET_SUCCESS';
export const ADMIN_REDACTION_GET_FAIL = 'ADMIN_REDACTION_GET_FAIL';

export const ADMIN_REDACTION_CLEAR = 'ADMIN_REDACTION_CLEAR';
